// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
'use strict';

var Link = require("../bindings/gatsby/link.js");
var Vrroom = require("vrroom/src/Vrroom.bs.js");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var TypedGlamor = require("bs-typed-glamor/src/TypedGlamor.bs.js");

var style = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.display(TypedGlamor.inlineBlock),
      /* :: */[
        TypedGlamor.opacity(0.75),
        /* :: */[
          TypedGlamor.fontSize(TypedGlamor.em(0.75)),
          /* :: */[
            TypedGlamor.lineHeight(TypedGlamor.em(1.6)),
            /* :: */[
              TypedGlamor.marginLeft(TypedGlamor.em(0.5)),
              /* :: */[
                TypedGlamor.whiteSpace(TypedGlamor.nowrap),
                /* :: */[
                  TypedGlamor.backgroundColor(TypedGlamor.hex("fff3")),
                  /* :: */[
                    TypedGlamor.padding2(TypedGlamor.zero, TypedGlamor.ex(1)),
                    /* :: */[
                      TypedGlamor.textDecoration(TypedGlamor.none),
                      /* :: */[
                        TypedGlamor.borderRadius(TypedGlamor.ex(0.5)),
                        /* :: */[
                          TypedGlamor.hover(/* :: */[
                                TypedGlamor.opacity(1),
                                /* :: */[
                                  TypedGlamor.textDecoration(TypedGlamor.underline),
                                  /* [] */0
                                ]
                              ]),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var component = ReasonReact.statelessComponent("Tag");

function make(name, url, $staropt$star, _) {
  var customStyle = $staropt$star ? $staropt$star[0] : "";
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function () {
              return ReasonReact.element(/* None */0, /* None */0, Link.make(url, /* Some */[TypedGlamor.toString(style) + (" " + customStyle)], /* None */0, /* array */[Vrroom.text(name)]));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* subscriptions */component[/* subscriptions */13],
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

var Tag = /* module */[
  /* style */style,
  /* component */component,
  /* make */make
];

var component$1 = ReasonReact.statelessComponent("Tag");

function make$1(name, _) {
  return /* record */[
          /* debugName */component$1[/* debugName */0],
          /* reactClassInternal */component$1[/* reactClassInternal */1],
          /* handedOffState */component$1[/* handedOffState */2],
          /* willReceiveProps */component$1[/* willReceiveProps */3],
          /* didMount */component$1[/* didMount */4],
          /* didUpdate */component$1[/* didUpdate */5],
          /* willUnmount */component$1[/* willUnmount */6],
          /* willUpdate */component$1[/* willUpdate */7],
          /* shouldUpdate */component$1[/* shouldUpdate */8],
          /* render */(function () {
              return ReasonReact.element(/* None */0, /* None */0, make(name, "/keyword/" + name, /* None */0, /* array */[]));
            }),
          /* initialState */component$1[/* initialState */10],
          /* retainedProps */component$1[/* retainedProps */11],
          /* reducer */component$1[/* reducer */12],
          /* subscriptions */component$1[/* subscriptions */13],
          /* jsElementWrapped */component$1[/* jsElementWrapped */14]
        ];
}

var Keyword = /* module */[
  /* component */component$1,
  /* make */make$1
];

var customStyle = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.border3(TypedGlamor.px(1), TypedGlamor.solid, TypedGlamor.currentColor),
      /* [] */0
    ]);

var component$2 = ReasonReact.statelessComponent("Tag");

function make$2(name, _) {
  return /* record */[
          /* debugName */component$2[/* debugName */0],
          /* reactClassInternal */component$2[/* reactClassInternal */1],
          /* handedOffState */component$2[/* handedOffState */2],
          /* willReceiveProps */component$2[/* willReceiveProps */3],
          /* didMount */component$2[/* didMount */4],
          /* didUpdate */component$2[/* didUpdate */5],
          /* willUnmount */component$2[/* willUnmount */6],
          /* willUpdate */component$2[/* willUpdate */7],
          /* shouldUpdate */component$2[/* shouldUpdate */8],
          /* render */(function () {
              return ReasonReact.element(/* None */0, /* None */0, make(name, "/category/" + name, /* Some */[TypedGlamor.toString(customStyle)], /* array */[]));
            }),
          /* initialState */component$2[/* initialState */10],
          /* retainedProps */component$2[/* retainedProps */11],
          /* reducer */component$2[/* reducer */12],
          /* subscriptions */component$2[/* subscriptions */13],
          /* jsElementWrapped */component$2[/* jsElementWrapped */14]
        ];
}

var Category = /* module */[
  /* customStyle */customStyle,
  /* component */component$2,
  /* make */make$2
];

exports.Tag = Tag;
exports.Keyword = Keyword;
exports.Category = Category;
/* style Not a pure module */



// WEBPACK FOOTER //
// ./src/components/Tag.js